"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _valueSeq = _interopRequireDefault(require("transmute/valueSeq"));

var _Constants = require("../Constants");

var _QuotasTableRecord = _interopRequireDefault(require("./QuotasTableRecord"));

function makeTablesMapForTypes(period) {
  return (0, _valueSeq.default)(_Constants.QUOTA_TYPES).reduce(function (typesMap, quotaType) {
    return typesMap.set(quotaType, new _QuotasTableRecord.default({
      period: period,
      quotaType: quotaType
    }));
  }, (0, _immutable.Map)());
}

var QuotasBaseRecord = (0, _immutable.Record)({
  WEEKLY: makeTablesMapForTypes(_Constants.QUOTA_PERIODS.WEEKLY),
  MONTHLY: makeTablesMapForTypes(_Constants.QUOTA_PERIODS.MONTHLY),
  QUARTERLY: makeTablesMapForTypes(_Constants.QUOTA_PERIODS.QUARTERLY),
  ANNUALLY: makeTablesMapForTypes(_Constants.QUOTA_PERIODS.ANNUALLY),
  isFetching: true,
  isSaving: false
}, 'QuotasRecord');

var QuotasRecord =
/*#__PURE__*/
function (_QuotasBaseRecord) {
  (0, _inherits2.default)(QuotasRecord, _QuotasBaseRecord);

  function QuotasRecord() {
    (0, _classCallCheck2.default)(this, QuotasRecord);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(QuotasRecord).apply(this, arguments));
  }

  (0, _createClass2.default)(QuotasRecord, [{
    key: "getTable",
    value: function getTable(period, type) {
      return this.getIn([period, type]);
    }
  }, {
    key: "hasTable",
    value: function hasTable(period, type) {
      return !this.get(period).get(type).isEmpty();
    }
  }, {
    key: "hasTables",
    value: function hasTables(period) {
      var _this = this;

      return !(0, _valueSeq.default)(_Constants.QUOTA_TYPES).filter(function (type) {
        return _this.hasTable(period, type);
      }).isEmpty();
    }
  }, {
    key: "addQuota",
    value: function addQuota(quotaRecord) {
      return this.updateIn([quotaRecord.period, quotaRecord.quotaType], function (quotasTableRecord) {
        return quotasTableRecord.setQuota(quotaRecord);
      });
    }
  }, {
    key: "addQuotas",
    value: function addQuotas(quotaRecordList) {
      return quotaRecordList.reduce(function (quotasRecord, quota) {
        return quotasRecord.addQuota(quota);
      }, this);
    }
  }, {
    key: "updateQuotas",
    value: function updateQuotas(updatedQuotas) {
      return updatedQuotas.reduce(function (quotasRecord, _ref) {
        var originalQuota = _ref.originalQuota,
            updatedQuota = _ref.updatedQuota;
        return quotasRecord.deleteQuota(originalQuota).addQuota(updatedQuota);
      }, this);
    }
  }, {
    key: "deleteQuota",
    value: function deleteQuota(quota) {
      return this.updateIn([quota.period, quota.quotaType], function (quotasTableRecord) {
        return quotasTableRecord.deleteQuota(quota);
      });
    }
  }, {
    key: "getRow",
    value: function getRow(_ref2) {
      var period = _ref2.period,
          quotaType = _ref2.quotaType,
          rowKey = _ref2.rowKey;
      return this.get(period).get(quotaType).rows.get(rowKey);
    }
  }]);
  return QuotasRecord;
}(QuotasBaseRecord);

exports.default = QuotasRecord;
module.exports = exports.default;